/* eslint-disable */
export enum MigrationStatus {
  NON_MIGRATION = 'NON_MIGRATION',
  ACTIVE = 'ACTIVE',
}
